import { fetchCountries } from '@basqet-dashboard/common/api';
import { Button, ProfileImage } from '@basqet-dashboard/common/components';
import { UserContext } from '@basqet-dashboard/common/context';
import { capitalize } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { BusinessDetailsForm } from './details-form';
import { PaymentSettings } from './payment-settings';

const BusinessSettings = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [countries, setCountries] = useState([]);
  const { user, setUser } = useContext(UserContext);

  useEffect(async () => {
    try {
      const data = await fetchCountries();
      setCountries(data);
    } catch (error) {
      const errorMessage = error.response && error.response.data.message;
      toast.error(errorMessage || 'Network Error', {
        toastId: errorMessage ? 'fetch-cournties' : 'network-error'
      });
    }
  }, []);
  return (
    <>
      <div className="card">
        <h2 className="card__header">Account Information</h2>
        {isEditing ? (
          <BusinessDetailsForm user={user} setUser={setUser} countries={countries} />
        ) : (
          <BusinessDetails user={user} onClick={setIsEditing} countries={countries} />
        )}
      </div>

      <PaymentSettings />
    </>
  );
};

const BusinessDetails = ({ user, onClick, countries }) => {
  const userCountry = countries.find(({ value }) => value === user.countryId);
  return (
    <>
      <ProfileImage location="settings" />

      <div className="business__details">
        <div className="business__details__item">
          <p className="details__title">Business name</p>
          <p className="details__value">{user && user.merchantName}</p>
        </div>
        <div className="business__details__item">
          <p className="details__title">Business email</p>
          <p className="details__value">{user && user.email}</p>
        </div>
        <div className="business__details__item">
          <p className="details__title">Business phone number</p>
          <p className="details__value">{user && user.phoneNumber}</p>
        </div>
        <div className="business__details__item">
          <p className="details__title">Country</p>
          <p className="details__value">{capitalize(userCountry && userCountry.label)}</p>
        </div>
      </div>
      <Button data-testid="business-details-edit-button" isFull variant="outline" onClick={onClick}>
        Edit
      </Button>
    </>
  );
};

BusinessDetails.propTypes = {
  user: PropTypes.object,
  onClick: PropTypes.func,
  countries: PropTypes.array
};

export { BusinessSettings };
